/**
 * Apply grid columns configuration to menu grids
 * Respects responsive breakpoints while allowing configuration
 */
export function applyGridColumns(element, columnsPerRow = 3) {
  if (!element) return;
  
  // Get viewport width
  const viewportWidth = window.innerWidth;
  
  // Apply responsive column count
  let actualColumns = columnsPerRow;
  
  // Override for smaller screens to maintain usability
  if (viewportWidth <= 768) {
    actualColumns = 1; // Single column on mobile
  } else if (viewportWidth <= 1200) {
    actualColumns = Math.min(3, columnsPerRow); // Allow 3 columns on tablets
  }
  
  // Apply the grid columns
  element.style.gridTemplateColumns = `repeat(${actualColumns}, 1fr)`;
}

/**
 * Setup responsive grid columns that update on window resize
 */
export function setupResponsiveGrid(element, columnsPerRow = 3) {
  if (!element) return;
  
  // Apply initial columns
  applyGridColumns(element, columnsPerRow);
  
  // Create resize handler
  const handleResize = () => {
    applyGridColumns(element, columnsPerRow);
  };
  
  // Add resize listener with debounce
  let resizeTimeout;
  const debouncedResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 150);
  };
  
  window.addEventListener('resize', debouncedResize);
  
  // Return cleanup function
  return () => {
    window.removeEventListener('resize', debouncedResize);
    clearTimeout(resizeTimeout);
  };
}